import React, { FC } from 'react'
import { type ClassValue } from 'clsx'
import cn from '../../lib/utils/cn'

interface LoaderProps {
	size?: number
	classNameWrapper?: ClassValue
	className?: ClassValue
}

const Loader: FC<LoaderProps> = ({
	size = 20,
	classNameWrapper = '',
	className = '',
}) => {
	return (
		<div
			className={cn('relative dark:bg-inherit', classNameWrapper)}
			style={{
				width: size,
				height: size,
			}}
		>
			<div
				className={cn(
					'absolute inset-0 rounded-full border-accent border-b-transparent',
					'animate-spin',
					size > 30 ? 'border-4' : 'border-2',
					className
				)}
			/>
		</div>
	)
}

export default Loader
